export default function OriginStory() {
  return (
    <section className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative h-[600px] rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/92b1c5c8ea135beebd91ad5f8fb69233.jpg"
              alt="Northside Kalamazoo"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2">
              <span className="text-xs font-bold text-white tracking-wide">THE ORIGIN</span>
            </div>

            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight">
              Built From<br />
              The Northside
            </h2>

            <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
              <p>
                <strong className="text-white font-bold">BillPlay Apparel was founded in 2017</strong> in the heart of Kalamazoo's Northside—a community defined by resilience, creativity, and unshakeable pride.
              </p>
              
              <p>
                We started with a simple mission: to create clothing that represents real people, real culture, and real ambition. Not manufactured hype. Not borrowed aesthetics. Just authentic style rooted in where we come from.
              </p>

              <p>
                The Northside taught us that <strong className="text-white font-bold">style is more than what you wear—it's how you move, how you carry yourself, and what you stand for.</strong> That's what BillPlay represents.
              </p>

              <p className="text-white font-bold text-xl">
                From Kalamazoo to everywhere. Culture over everything.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}